module.exports = {"contact":"api/v/1/contact"}


//////////////////
// WEBPACK FOOTER
// ./src/config/endpoints.json
// module id = B5xK
// module chunks = 1